import { Box } from "@mui/system";
import React, { ReactNode } from "react";
import { shape, string, object } from "prop-types";

type UploadModalCarouselItem = {
  name?: string;
  heading?: string;
  description?: ReactNode;
};

type UploadModalCarouselProps = {
  item: UploadModalCarouselItem;
};

export const UploadModalCarousel = (props: UploadModalCarouselProps) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignContent: "space-between",
          p: 3,
          m: 0,
          color: "white",
          maxHeight: `calc(100vh - 150px )`,
          height: "500px",
          // height: `calc(100vh - 200px )`,
          // height: "inherit",
          borderRadius: 1,
          // maxHeight: 450,
          // height: `calc(100% - 150px )`,

          // backgroundColor: "Yellow"
        }}
      >
        <Box>
          <h2>{props.item.name}</h2>
        </Box>
        <Box>
          <h1>{props.item.heading}</h1>
          <p>{props.item.description}</p>
        </Box>
      </Box>
    </>
  );
};

UploadModalCarousel.propTypes = {
  item: shape({
    name: string,
    heading: string,
    description: object,
  }).isRequired,
};
